/**
 * Skymosity audience integration
 * @module
 */



var VENDOR = 'skymosity';

var pluginAudienceSkymosity: AudiencePluginConfig = {
  provider: require('core/plugins/providers/default_jsonp'),
  matcher: require('core/plugins/matchers/key_value'),
  vendor: VENDOR,
};

module.exports = function(PluginManager) {
  PluginManager.registerAudiencePlugin(pluginAudienceSkymosity);
};

if (__TEST__) {
  module.exports.plugin = pluginAudienceSkymosity;
}
